import React from 'react';
import styled from 'styled-components';

import { SCREEN_WIDTH_BREAKPOINTS } from 'core/constants';

export const ItemContainer = styled.div<{
  reverse: boolean;
}>`
  display: flex;
  flex-direction: ${(props) => (props.reverse ? 'row-reverse' : 'row')};
  gap: 5px;
`;

export const ItemLayout = styled.div<{ $isAuthor: boolean }>`
  display: flex;
  flex-direction: column;
  min-width: 80%;
  max-width: 80%;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.palette.action.hover};
  background: ${({ $isAuthor, theme }) => ($isAuthor ? theme.palette.primary.light : theme.tint.primary.subtle)};
`;

export const ItemHeader = styled.div`
  display: flex;
`;

export const ItemHeaderData = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  justify-content: space-between;
  margin: 10px;
`;

export const ItemDate = styled.p<{ $isAuthor: boolean }>`
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 166%; /* 19.92px */
  letter-spacing: 0.4px;
  color: ${({ $isAuthor, theme }) => ($isAuthor ? theme.palette.common.white : 'rgba(0, 0, 0, 0.60)')};
  margin: 0px;
`;

export const ItemContent = styled.div`
  margin: 0px 10px 10px 10px;
`;

export const UserContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-self: center;
`;

export const UserName = styled.p<{ $isAuthor: boolean }>`
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 138.462% */
  letter-spacing: 0.16px;
  color: ${({ $isAuthor, theme }) => ($isAuthor ? theme.palette.common.white : theme.palette.text.primary)};
  margin: 0px;
  // add ellipsis only on small screens
  @media (max-width: ${SCREEN_WIDTH_BREAKPOINTS.MEDIUM_SCREEN}px) {
    max-width: 180px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;

export const CommentSubtitle = styled.p<{ $isAuthor: boolean }>`
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.16px;
  color: ${({ $isAuthor, theme }) => ($isAuthor ? theme.palette.common.white : 'rgba(0, 0, 0, 0.60)')};
  margin: 0px;
  margin-left: ${({ $isAuthor }) => ($isAuthor ? '2px' : '5px')};
`;
